<script>
    import io from 'socket.io-client';
    import { createEventDispatcher } from 'svelte';
    import { trainerTexts as texts } from './trainerTexts.js';
    import CopytoClip from './CopytoClip.svelte';
    import GameStatus from './GameStatus.svelte';
    import Timer from '../Player/Timer.svelte';
    export let isAttentionVisible = false;
    export let timerTools = {};
    export let viewState = {
        isVotingRunning: false,
        isVotingOver: false,
        isSolutionVisible: false,
    };
    export let timeOfDestroyTimer = 0;
    export let timerState = true;
    export let timer = 0;

    let isOnline = false;
    export let isTrainerSummoned = false;
    let gameSocket;
    const dispatch = createEventDispatcher();
    import Swal from 'sweetalert2';

    export let game;
    export let lang = 'pl';
    export let bridgeState = {};
    export let playerList = {
        engineers: [],
        council: [],
    };
    const connectionData = new URL(window.location);

    let GAMEURL = 'http://localhost:8080/';

    if (connectionData.hostname.includes('zulu')) {
        GAMEURL = 'https://zulu-stage.mindlab.pl/';
    } else if (connectionData.hostname.includes('sava')) {
        GAMEURL = 'https://sava.mindlab.pl/';
    }
    const selectTexts = {
        pl: 'Wybierz  język',
        eng: 'Choose language',
    };
    const langSelectPrefs = {
        title: 'Wybierz język',
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: '#233e63',
        cancelButtonColor: '#941728',
        cancelButtonText: 'English',
        confirmButtonText: 'Polski',
        backdrop: false,
    };

    async function selectLang() {
        langSelectPrefs.title = selectTexts[lang];
        let language = await Swal.fire(langSelectPrefs);
        let gameLang;
        if (language.isConfirmed) {
            gameLang = 'pl';
        } else gameLang = 'eng';
        return gameLang;
    }

    async function activateGame() {
        const confirmation = await Swal.fire({
            title: texts[lang].you_sure,
            text: texts[lang].cant_change_players,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#233e63',
            cancelButtonColor: '#941728',
            cancelButtonText: texts[lang].cancel_create,
            confirmButtonText: texts[lang].confirm_create,
            backdrop: false,
        });
        if (!confirmation.isConfirmed) return;
        const gameLang = await selectLang(lang);
        gameSocket.emit('start_game', gameLang);
        // const isSuccess = await trainerTools.activateGame(game.code);
        // if (isSuccess) {
        //     Swal.fire('gra uruchomiona');
        // } else {
        //     console.log('incorrect activation');
        // }
    }

    function addPlayer() {
        if (game.playersCount === 8) {
            Swal.fire('Max graczy to 8');
            return;
        }
        dispatch('addDeletePlayer', {
            gameId: game.gameId,
            gameCode: game.code,
            change: 'add',
        });
    }
    function deletePlayer() {
        if (game.playersCount === 5) {
            Swal.fire('Min graczy to 5');
            return;
        }
        dispatch('addDeletePlayer', {
            gameId: game.gameId,
            gameCode: game.code,
            change: 'delete',
        });
    }

    function copy(content) {
        const app = new CopytoClip({
            target: document.getElementById('clipboard'),
            props: { content },
        });
        app.$destroy();
    }

    async function startWaitingRoom() {
        const checkSocket = io({
            query: { game: game.code },
        });
        checkSocket.on('hello', () => {
            console.log(`access granted, conneting to ${game.code}`);
            console.log(game.code);
            gameLogin(game.code);
            checkSocket.disconnect();
        });
        checkSocket.on('invalid', () => (myGame = 'bzzzzzzzzzzzzz'));
    }
    async function gameLogin(currGame) {
        console.log(currGame);
        gameSocket = io(`/${currGame}`);

        gameSocket.on('hello in the game', async () => {
            console.log('login');
            gameSocket.emit('trainer_login');
        });

        gameSocket.on('trainer_confirmed', async (data) => {
            console.log('tc', data);
            playerList.engineers = data.playersList.engineers;
            playerList.council = data.playersList.council;
            isOnline = true;
            viewState = data.viewState;
            bridgeState = data.bridgeState;
            if (data.timerData) {
                const now = Date.now();
                console.log(now, '    ', data.timerData.startTime);
                const diff = Math.floor(
                    (now - 300 - data.timerData.startTime) / 1000
                );
                console.log(diff, '    ', timer);

                if (data.timerData.duration * 60 - diff > 0) {
                    setTimeout(() => {
                        timerTools.startTimer(
                            data.timerData.duration * 60 - diff,
                            true
                        );
                    }, 300);
                }
            }
        });

        gameSocket.on('no_access', (data) => {
            myGame = JSON.stringify(data);
        });

        gameSocket.on('userlist', (data) => {
            console.log('userlist!', data);
            playerList.engineers = data.engineers;
            playerList.council = data.council;
        });
        gameSocket.on('bridge_changed_on_server', (data) => {
            bridgeState = data;
        });
        gameSocket.on('game_started', (data) => {
            game.isGameOn = data;
        });
        gameSocket.on('wrong_playercount', () => {
            Swal.fire('Nieprawidłowa liczba graczy!');
        });
        gameSocket.on('trainer_summoned', () => {
            isTrainerSummoned = true;
            isAttentionVisible = true;
        });
        gameSocket.on('trainer_started_timer', (time) => {
            timerTools.startTimer(time);
        });
        gameSocket.on('voting_break', (data) => {
            viewState = data;
        });
        gameSocket.on('trainer_started_voting', (data) => {
            viewState = data.viewState;
        });

        gameSocket.on('player_vote', (data) => {
            console.log('player vote', data);
            playerList.council.players = data;
        });

        gameSocket.on('not_everybody_voted', () => {
            Swal.fire('Not everybody voted!');
        });
        gameSocket.on('not_everybody_sheeped', () => {
            Swal.fire('Not everybody sheeped!');
        });
        gameSocket.on('voting_not_accepted', () => {
            Swal.fire('Not accepted');
        });
        gameSocket.on('trainer_ended_voting', (data) => {
            viewState = data.viewState;
        });
        gameSocket.on('voting_not_agreed', (data) => {
            viewState = data;
        });
        gameSocket.on('toggle_solution', (data) => {
            viewState = data;
        });
        gameSocket.on('toggle_sheep', (data) => {
            viewState = data.viewState;
        });
        gameSocket.on('sheeping_ended', (data) => {
            viewState = data.viewState;
            console.log(viewState);
        });
        gameSocket.on('game_over', (data) => {
            dispatch('refresh');
        });
        gameSocket.on('changedNumPl', (data) => {
            dispatch('refresh');
        });
    }

    $: if (game.wasPlayerNumChanged) {
        if (gameSocket) {
            console.log('gs found');
            gameSocket.emit('changeNumPlayers');
        } else {
            console.log('no gameSocketfound');
        }
        game.wasPlayerNumChanged = false;
    }
</script>

<div
    class="game"
    class:single-game={!game.isGameOn && !game.isGameEnd}
    class:running={game.isGameOn}
    class:closed={game.isGameEnd}
>
    <div class="section-bar">
        <div class="section-text">
            {texts[lang].game}
            {game.code}
            {game.lang ? ', ' + texts[lang].lang + ':' + game.lang : ''}
        </div>
        <hr />
    </div>
    <p class="p__game">
        {texts[lang].game_state}
        {#if game.isGameOn && !game.isGameEnd}
            {texts[lang].active}
        {:else if game.isGameEnd}
            {texts[lang].end}
        {:else}
            {texts[lang].inactive}
        {/if}
        <br />
        {texts[lang].players}
        {game.playersCount}
        {texts[lang].variants}
        {texts.variants[lang][game.playersCount - 5]}
    </p>

    <button
        class="btn btn__smaller"
        class:btn--inactive={game.isGameOn || game.isGameEnd}
        disabled={game.isGameOn || game.isGameEnd}
        on:click={() =>
            dispatch('deleteGame', {
                gameId: game.gameId,
                gameCode: game.code,
            })}
        >{texts[lang].delete_game}
    </button>
    <button
        disabled={game.isGameOn || game.isGameEnd}
        class="btn btn__smaller"
        class:btn--inactive={game.isGameOn || game.isGameEnd}
        on:click={addPlayer}
        >{texts[lang].add_player}
    </button>
    <button
        disabled={game.isGameOn || game.isGameEnd}
        class:btn--inactive={game.isGameOn || game.isGameEnd}
        class="btn btn__smaller"
        on:click={deletePlayer}
        >{texts[lang].subtr_player}
    </button>

    <button
        class="btn btn__smaller"
        on:click={startWaitingRoom}
        class:btn--inactive={game.isGameEnd}
        disabled={game.isGameEnd}
    >
        {!game.isGameOn ? texts[lang].waiting_room : texts[lang].game_details}
    </button>
    <hr class="u-flex-break" />
    {#if isOnline}
        <div class="dropdown">
            <input
                type="checkbox"
                class="drop-switch"
                id="drop-council{game.code}"
            />
            <label
                for="drop-council{game.code}"
                class="btn__reverse drop-label"
            >
                <span class="btn-text__main">{texts[lang].council_members}</span
                >
                <div class="icon" />
                <button
                    class="btn btn__smaller"
                    on:click={() =>
                        copy(
                            GAMEURL + '?game=' + game.code + '&player=council'
                        )}>{texts[lang].copy_link}</button
                >
            </label>
            <ul class="submenu">
                {#each playerList.council[game.isGameOn ? 'players' : 'waitingRoom'] as council}
                    {#if council.playerName}
                        <!-- do dodania statusu głosowania: class="u-voted-status" do elementu li -->
                        <li class:u-voted-status={council.voteResult}>
                            {council.playerName}
                            <div
                                class="player__img {game.isGameOn
                                    ? `player__img--${council.character}`
                                    : ''}"
                                class:u-offline={game.isGameOn &&
                                    !council.isOnline}
                            >
                                <div class="player__img-character">
                                    {texts[lang][council.character]}
                                </div>
                            </div>
                        </li>
                    {/if}
                {:else}
                    <li>
                        {texts[lang].empty_waiting_info}
                    </li>
                {/each}
            </ul>
        </div>

        <div class="dropdown">
            <input
                type="checkbox"
                class="drop-switch"
                id="drop-engineers{game.code}"
            />
            <label
                for="drop-engineers{game.code}"
                class="btn__reverse drop-label"
            >
                <span class="btn-text__main">{texts[lang].engineers}</span>
                <div class="icon" />
                <button
                    class="btn btn__smaller"
                    on:click={() =>
                        copy(
                            GAMEURL + '?game=' + game.code + '&player=engineers'
                        )}>{texts[lang].copy_link}</button
                >
            </label>
            <ul class="submenu">
                {#each playerList.engineers[game.isGameOn ? 'players' : 'waitingRoom'] as engineer}
                    {#if engineer.playerName}
                        <li>
                            <p>{engineer.playerName}</p>
                            <div
                                class="player__img {game.isGameOn
                                    ? `player__img--${engineer.character}`
                                    : ''}"
                                class:u-offline={game.isGameOn &&
                                    !engineer.isOnline}
                            >
                                <div class="player__img-character">
                                    {texts[lang][engineer.character]}
                                </div>
                            </div>
                        </li>
                    {/if}
                {:else}
                    <li>
                        {texts[lang].empty_waiting_info}
                    </li>
                {/each}
            </ul>
        </div>

        <button
            class="btn btn__smaller"
            disabled={game.isGameOn || game.isGameEnd}
            class:btn--inactive={game.isGameOn || game.isGameEnd}
            on:click={activateGame}
            >{texts[lang].activate_game}
        </button>
        <hr class="u-flex-break" />
        <!-- {#if game.isGameOn} -->
        <GameStatus
            {bridgeState}
            {viewState}
            {GAMEURL}
            {lang}
            gameCode={game.code}
            isGameOn={game.isGameOn}
            isGameEnd={game.isGameEnd}
            bind:isTrainerSummoned
            on:start_timer={(ev) => {
                gameSocket.emit('start_timer', ev.detail.timer);
            }}
            on:start_voting={() => gameSocket.emit('start_voting')}
            on:break_voting={() => gameSocket.emit('break_voting')}
            on:end_voting={() => gameSocket.emit('end_voting')}
            on:desummon_trainer={() => gameSocket.emit('desummon_trainer')}
            on:toggle_solution={() => gameSocket.emit('toggle_solution')}
            on:toggle_sheep={() => gameSocket.emit('toggle_sheep')}
            on:close_game={() => gameSocket.emit('game_over')}
            on:sheeping_ended={() => gameSocket.emit('end_sheeps')}
            ><Timer
                bind:timerState
                bind:timerTools
                bind:timer
                bind:timeOfDestroyTimer
            /></GameStatus
        >
        <!-- {/if} -->
    {/if}
</div>
